<template>
   <dashboard-layout>
      <v-container fluid class="down-top-padding py-0">
         <BaseBreadcrumb
            :title="page.title"
            :icon="page.icon"
            :breadcrumbs="breadcrumbs"
         ></BaseBreadcrumb>
         <v-row>
           <v-col cols="12">
              <table-adm-membership></table-adm-membership>
           </v-col>
         </v-row>
      </v-container>
   </dashboard-layout>
</template>

<script>
import BaseBreadcrumb from '@/components/BaseBreadcrumb.vue'
import DashboardLayout from '@/Layouts/DashboardLayout.vue'
import TableAdmMembership from './Tables/TableAdmMembership.vue'

export default {
   name: "MOAMembership",
   components: {
      DashboardLayout,
      BaseBreadcrumb,
      TableAdmMembership,
   },
   props: {
      user: Object
   },

   data() {
      return {
         page: {
         title: "Manage Membership",
         },
         breadcrumbs: [
            {
               text: "Dashboard",
               disabled: false,
               to: "/dashboard",
            },
            {
               text: "Membership",
               disabled: true,
            },
         ],
      }
   },


   methods: {
      dashtype: function() {
         return (this.user.membertype === 'members' ? 'Members Dashboard' : 'Admin Dashboard')
      }
   },

   computed: {

   }


};
</script>

<style>
</style>
